import { Action } from "@ngrx/store";
import {
  CourseGroupDashboard,
  GroupTeacherDashboard,
} from "src/app/shared/interfaces/group";
import { PaginationData } from "src/app/shared/interfaces/orgadmin/course-organization";
import { Guid } from "src/app/shared/types/guid";

export const GET_DASHBOARD_STUDENT = "[Dashboard Method] GetDashboardStudent";
export const GET_DASHBOARD_STUDENT_COMPLETED =
  "[Dashboard Method] GetDashboardStudentCompleted";
export const GET_DASHBOARD_TEACHER = "[Dashboard Method] GetDashboardTeacher";
export const GET_DASHBOARD_TEACHER_COMPLETED =
  "[Dashboard Method] GetDashboardTeacherCompleted";
export const ACCEPT_INVITATION = "[Dashboard Method] AcceptInvitation";
export const REJECT_INVITATION = "[Dashboard Method] RejectInvitation";

export class GetDashboardStudent implements Action {
  readonly type = GET_DASHBOARD_STUDENT;
  constructor(public payload: { page: number }) {}
}

export class GetDashboardStudentCompleted implements Action {
  readonly type = GET_DASHBOARD_STUDENT_COMPLETED;
  constructor(public payload: PaginationData<CourseGroupDashboard>) {}
}

export class GetDashboardTeacher implements Action {
  readonly type = GET_DASHBOARD_TEACHER;

  constructor(public payload: { page: number }) {}
}

export class GetDashboardTeacherCompleted implements Action {
  readonly type = GET_DASHBOARD_TEACHER_COMPLETED;

  constructor(public payload: PaginationData<GroupTeacherDashboard>) {}
}

export class AcceptInvitation implements Action {
  readonly type = ACCEPT_INVITATION;
  constructor(
    public payload: { invitationId: Guid; groupId?: Guid; courseId?: Guid },
  ) {}
}

export class RejectInvitation implements Action {
  readonly type = REJECT_INVITATION;
  constructor(public payload: { invitationId: Guid }) {}
}

export type DashboardActions =
  | GetDashboardStudent
  | GetDashboardStudentCompleted
  | GetDashboardTeacher
  | GetDashboardTeacherCompleted
  | AcceptInvitation
  | RejectInvitation;
